import api from './api';

export const PAGARME_ONBOARDING_TOKEN_STORAGE_KEY = 'pagarmeOnboardingToken';

export type PublicPagarmeBootstrap = {
  parishName: string;
  expiresAt: string;
  parishBasics: Record<string, unknown>;
  withdrawalData?: { pixKeyType?: string };
  hasPixConfigured: boolean;
  pagarMeRecipientId: string | null;
  recipientProfile: Record<string, unknown>;
  recipientSynced: boolean;
  pendencies: string[];
};

export async function fetchPagarmePublicBootstrap(token: string) {
  const { data } = await api.get<{ success: boolean; data: PublicPagarmeBootstrap }>(
    '/public/pagarme-parish-onboarding/bootstrap',
    { params: { token } }
  );
  return data;
}

export async function submitPagarmePublicOnboarding(body: Record<string, unknown>) {
  const { data } = await api.patch<{ success: boolean; message?: string; data?: Record<string, unknown> }>(
    '/public/pagarme-parish-onboarding',
    body
  );
  return data;
}
